import { useStoreMap } from 'effector-react'
import { driverModel } from '~/entities/Driver'
import { DocumentsIcon } from '~/shared/ui/icons'
import { Wrapper, Title, Descriptions, ImageWrapper, Link } from './styled'

export function DriverCurrentOccupation() {
  const currentOccupationTitle = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getCurrentOccupation()?.getTitle(),
  )

  return (
    <Link to='/driver-occupations' data-testid='driver-current-occupation'>
      <Wrapper>
        <ImageWrapper>
          <DocumentsIcon />
        </ImageWrapper>
        <div>
          <Title>Тип занятости</Title>
          <Descriptions>{currentOccupationTitle || 'Не выбран'}</Descriptions>
        </div>
      </Wrapper>
    </Link>
  )
}
